import { opportunitySyncProfilesService } from '@/services/opportunity-sync-profiles.service';
import axios from 'axios';

const initialState = () => ({
  contacts: [],
  suggestedContacts: [],
  contactsManualSearchResults: [],
  status: {
    error: null,
    pending: false,
    pendingAddContact: false,
    resolved: false,
    rejected: false,
  },
});

const state = initialState();

const CancelToken = axios.CancelToken;
let cancelTokens = {
  getAllContacts: null,
  searchContacts: null,
};

const actions = {
  getSuggestedContacts({ commit }, { syncProfileId, accountId, searchQuery }) {
    commit('GET_SUGGESTED_CONTACTS');
    return opportunitySyncProfilesService.searchContact({ syncProfileId, accountId, searchQuery }).then(
      (suggestedContacts) => {
        return commit('SUCCESS_GET_SUGGESTED_CONTACTS', suggestedContacts);
      },
      (error) => {
        if (!axios.isCancel(error)) {
          commit('ERROR', error);
          throw error;
        }
      },
    );
  },
  getAllContacts({ commit }, { syncProfileId, accountId }) {
    if (cancelTokens.getAllContacts) {
      cancelTokens.getAllContacts.cancel('Multiple requests.');
    }
    cancelTokens.getAllContacts = CancelToken.source();

    commit('GET_ALL_CONTACTS');
    return opportunitySyncProfilesService
      .getAllContacts({ syncProfileId, accountId, cancelToken: cancelTokens.getAllContacts })
      .then(
        (contacts) => {
          commit('SUCCESS_GET_ALL_CONTACTS', contacts);
          return contacts;
        },
        (error) => {
          if (!axios.isCancel(error)) {
            commit('ERROR', error);
            throw error;
          }
        },
      );
  },
  searchContacts({ commit }, { syncProfileId, accountId, searchQuery }) {
    if (cancelTokens.searchContacts) {
      cancelTokens.searchContacts.cancel('Multiple requests.');
    }
    cancelTokens.searchContacts = CancelToken.source();

    commit('SEARCH_CONTACTS');
    return opportunitySyncProfilesService
      .searchContact({ syncProfileId, accountId, searchQuery, cancelToken: cancelTokens.searchContacts })
      .then(
        (response) => {
          commit('SUCCESS_SEARCH_CONTACTS', response);
          return response;
        },
        (error) => {
          if (!axios.isCancel(error)) {
            throw error;
          }
        },
      );
  },
  addContact({ commit }, { syncProfileId, externalAccountId, firstName, lastName, email, telephone }) {
    commit('ADD_CONTACT');
    return opportunitySyncProfilesService
      .addContact({ syncProfileId, externalAccountId, firstName, lastName, email, telephone })
      .then(
        (contact) => {
          commit('SUCCESS_ADD_CONTACT', contact);
          return contact;
        },
        (error) => {
          if (!axios.isCancel(error)) {
            commit('ERROR');
            throw error;
          }
        },
      );
  },
};

const mutations = {
  GET_SUGGESTED_CONTACTS(state) {
    state.status = {
      error: null,
      resolved: false,
      rejected: false,
    };
    state.suggestedContacts = [];
  },
  GET_ALL_CONTACTS(state) {
    state.status = {
      error: null,
      pending: true,
      resolved: false,
      rejected: false,
    };
    state.contacts = [];
  },
  SUCCESS_GET_SUGGESTED_CONTACTS(state, suggestedContacts) {
    state.status = {
      ...state.status,
      pending: false,
      resolved: true,
    };
    state.suggestedContacts = suggestedContacts;
  },
  SUCCESS_GET_ALL_CONTACTS(state, contacts) {
    state.status = {
      ...state.status,
      pending: false,
      resolved: true,
    };
    state.contacts = contacts;
  },
  SEARCH_CONTACTS(state) {
    state.status = {
      error: null,
      pending: true,
      resolved: false,
      rejected: false,
    };
    state.contactsManualSearchResults = [];
  },
  SUCCESS_SEARCH_CONTACTS(state, results) {
    state.status = {
      ...state.status,
      pending: false,
      resolved: true,
    };
    state.contactsManualSearchResults = results;
  },
  ADD_CONTACT(state) {
    state.status = {
      pendingAddContact: true,
    };
  },
  SUCCESS_ADD_CONTACT(state, contact) {
    state.status = {
      pendingAddContact: false,
    };
    state.contacts.push(contact);
  },
  ERROR(state, error) {
    state.status = {
      error,
      pending: false,
      resolved: false,
      rejected: true,
    };
  },
};

const getters = {
  contacts: (state) => state.contacts,
  suggestedContacts: (state) => state.suggestedContacts,
  contactsManualSearchResults: (state) => state.contactsManualSearchResults,

  // status
  error: (state) => state.status.error,
  pending: (state) => state.status.pending,
  pendingAddContact: (state) => state.status.pendingAddContact,
  rejected: (state) => state.status.rejected,
  resolved: (state) => state.status.resolved,
};

export const opportunitySyncProfileContacts = {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
